import "./icon.custom.caretUpDownCustom.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomCaretUpDownCustomProps = ComponentProps<"svg">
function IconCustomCaretUpDownCustom(props: IconCustomCaretUpDownCustomProps) {
  const {
    className,
    viewBox = "0 0 24 24",
    fill = "none",
    width = 16,
    height = 16,
    ...svgProps
  } = props

  return (
    <svg
      className={cn("caret-up-down-custom", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      aria-hidden
      {...svgProps}
    >
      <path
        className="caret-up-down-custom__path"
        d="M18 9 12 3 6 9H18ZM18 15 12 21 6 15H18Z"
      />
    </svg>
  )
}

export default IconCustomCaretUpDownCustom
